"use strict";
/*
  The MIT License
  
  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms
  
  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:
  
  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.
  
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("./core");
exports.coreReducer = core_1.coreReducer;
exports.errorsAt = core_1.errorsAt;
var default_data_1 = require("./default-data");
var renderers_1 = require("./renderers");
exports.rendererReducer = renderers_1.rendererReducer;
var uischemas_1 = require("./uischemas");
exports.findMatchingUISchema = uischemas_1.findMatchingUISchema;
exports.uischemaRegistryReducer = uischemas_1.uischemaRegistryReducer;
var i18n_1 = require("./i18n");
exports.i18nReducer = i18n_1.i18nReducer;
var generators_1 = require("../generators");
var cells_1 = require("./cells");
exports.cellReducer = cells_1.cellReducer;
var config_1 = require("./config");
exports.configReducer = config_1.configReducer;
var get_1 = tslib_1.__importDefault(require("lodash/get"));
exports.jsonFormsReducerConfig = {
    core: core_1.coreReducer,
    renderers: renderers_1.rendererReducer,
    cells: cells_1.cellReducer,
    config: config_1.configReducer,
    uischemas: uischemas_1.uischemaRegistryReducer,
    defaultData: default_data_1.defaultDataReducer,
    i18n: i18n_1.i18nReducer
};
/**
 * Finds a registered UI schema to use, if any.
 * @param schema the JSON schema describing the data to be rendered
 * @param schemaPath the according schema path
 * @param path the instance path
 * @param fallbackLayoutType the type of the layout to use
 * @param control may be checked for embedded inline uischema options
 */
exports.findUISchema = function (uischemas, schema, schemaPath, path, fallbackLayoutType, control, rootSchema) {
    if (fallbackLayoutType === void 0) { fallbackLayoutType = 'VerticalLayout'; }
    // handle options
    if (control && control.options && control.options.detail) {
        if (typeof control.options.detail === 'string') {
            if (control.options.detail.toUpperCase() === 'GENERATE') {
                // force generation of uischema
                return generators_1.Generate.uiSchema(schema, fallbackLayoutType);
            }
        }
        else if (typeof control.options.detail === 'object') {
            // check if detail is a valid uischema
            if (control.options.detail.type &&
                typeof control.options.detail.type === 'string') {
                return control.options.detail;
            }
        }
    }
    // default
    var uiSchema = uischemas_1.findMatchingUISchema(uischemas)(schema, schemaPath, path);
    if (uiSchema === undefined) {
        return generators_1.Generate.uiSchema(schema, fallbackLayoutType, '#', rootSchema);
    }
    return uiSchema;
};
exports.getErrorAt = function (instancePath, schema) { return function (state) {
    return core_1.errorAt(instancePath, schema)(state.jsonforms.core);
}; };
exports.getSubErrorsAt = function (instancePath, schema) { return function (state) { return core_1.subErrorsAt(instancePath, schema)(state.jsonforms.core); }; };
exports.getConfig = function (state) { return state.jsonforms.config; };
exports.getLocale = function (state) {
    return i18n_1.fetchLocale(get_1.default(state, 'jsonforms.i18n'));
};
exports.getLocalizedSchema = function (locale) { return function (state) { return i18n_1.findLocalizedSchema(locale)(get_1.default(state, 'jsonforms.i18n')); }; };
exports.getLocalizedUISchema = function (locale) { return function (state) {
    return i18n_1.findLocalizedUISchema(locale)(get_1.default(state, 'jsonforms.i18n'));
}; };
//# sourceMappingURL=reducers.js.map